/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResults
 */
export interface FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResults {
    /**
     * 
     * @type {boolean}
     * @memberof FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResults
     */
    Success: boolean;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResults
     */
    PurchaseToken: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResults interface.
 */
export function instanceOfFxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResults(value: object): value is FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResults {
    if (!('Success' in value) || value['Success'] === undefined) return false;
    if (!('PurchaseToken' in value) || value['PurchaseToken'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResultsFromJSON(json: any): FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResults {
    return FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResultsFromJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResults {
    if (json == null) {
        return json;
    }
    return {
        
        'Success': json['Success'],
        'PurchaseToken': json['PurchaseToken'],
    };
}

export function FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResultsToJSON(json: any): FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResults {
    return FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResultsToJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResultsToJSONTyped(value?: FxIdWebFeaturesStoreYandexGamesPurchaseResponseResponseTokenResults | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Success': value['Success'],
        'PurchaseToken': value['PurchaseToken'],
    };
}

